// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__uX15Q","body":"style__body__j6uCP","header":"style__header__B-Xu3","footer":"style__footer__UTb+q"};